module.exports = __webpack_public_path__ + "img/logo-dark.37cbc9c5.png";